/* tslint:disable */

declare var Object: any;
export interface SsobranchserviceInterface {
  "id"?: number;
}

export class Ssobranchservice implements SsobranchserviceInterface {
  "id": number;
  constructor(data?: SsobranchserviceInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `Ssobranchservice`.
   */
  public static getModelName() {
    return "Ssobranchservice";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of Ssobranchservice for dynamic purposes.
  **/
  public static factory(data: SsobranchserviceInterface): Ssobranchservice{
    return new Ssobranchservice(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'Ssobranchservice',
      plural: 'Ssobranchservices',
      path: 'Ssobranchservices',
      idName: 'id',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/models/Ssobranchservice.ts